<script setup lang="ts">
const currentYear = new Date().getFullYear()

const footerLinks = {
  'Platform': [
    { name: 'Services', path: '/services' },
    { name: 'Data Centers', path: '/data-centers' },
    { name: 'Security & Compliance', path: '/security' },
    { name: 'API Documentation', path: '/api-docs' },
    { name: 'Status', path: '/status' }
  ],
  'Company': [
    { name: 'About Us', path: '/about/story' },
    { name: 'Mission & Values', path: '/about/mission' },
    { name: 'Careers', path: '/careers' }
  ],
  'Media': [
    { name: 'Press Releases', path: '/media/press' },
    { name: 'Media Kit', path: '/media/media-kit' },
    { name: 'Awards', path: '/media/awards' }
  ],
  'Legal': [
    { name: 'Terms of Service', path: '/legal/terms' },
    { name: 'Privacy Policy', path: '/legal/privacy' },
    { name: 'Acceptable Use', path: '/legal/acceptable-use' }
  ]
}
</script>

<template>
  <footer class="bg-gray-50 dark:bg-gray-800">
    <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
      <div class="grid grid-cols-1 md:grid-cols-5 gap-8">
        <div>
          <div class="flex items-center">
            <i class="fas fa-cloud text-2xl text-primary-400 mr-2"></i>
            <h3 class="text-lg font-semibold text-gray-900 dark:text-white">Syniac</h3>
          </div>
          <p class="mt-4 text-gray-600 dark:text-gray-400">
            Empowering businesses with next-generation cloud computing solutions.
          </p>
          <div class="mt-4 flex space-x-4">
            <a href="#" class="text-gray-400 hover:text-gray-500 dark:hover:text-gray-300">
              <i class="fab fa-twitter text-xl"></i>
            </a>
            <a href="https://www.linkedin.com/company/syniac/" class="text-gray-400 hover:text-gray-500 dark:hover:text-gray-300">
              <i class="fab fa-linkedin text-xl"></i>
            </a>
            <a href="https://github.com/Syniac" class="text-gray-400 hover:text-gray-500 dark:hover:text-gray-300">
              <i class="fab fa-github text-xl"></i>
            </a>
          </div>
        </div>
        <template v-for="(links, category) in footerLinks" :key="category">
          <div>
            <h3 class="text-sm font-semibold text-gray-900 dark:text-white uppercase tracking-wider">
              {{ category }}
            </h3>
            <ul class="mt-4 space-y-4">
              <li v-for="link in links" :key="link.name">
                <RouterLink 
                  :to="link.path" 
                  class="text-base text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-white"
                >
                  {{ link.name }}
                </RouterLink>
              </li>
            </ul>
          </div>
        </template>
      </div>
      <div class="mt-8 pt-8 border-t border-gray-200 dark:border-gray-700">
        <p class="text-base text-gray-400 dark:text-gray-500 text-center">
          © {{ currentYear }} Syniac. All rights reserved.
        </p>
      </div>
    </div>
  </footer>
</template>
